import { claimSublimitsPrepare } from '@flows/configs/dental/utils/claimSublimits'
import { underwritingStep } from '@flows/configs/dental/utils/navigation'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

import { claimSublimitRows } from './dental_previous_insurance'

export const claimSublimitInfoBox = (params: StepConfigParams) =>
  ({
    type: 'infoBox',
    noPadding: true,
    bgColor: 'grey200',
    contentConfiguration: [
      {
        type: 'list',
        isBoldLabel: true,
        padding: 'none',
        paddingLeft: 'none',
        gapY: 'small',
        data: claimSublimitRows(params, {
          firstYearKey: 'claim_sublimit_for_first_year',
          boldUnlimited: false,
        }),
      },
    ],
  }) as const

const dental_previous_coverage_breakdown = (
  params: StepConfigParams,
  plaform: 'native' | 'web'
) => {
  const nextStep = underwritingStep(plaform)

  return {
    onPrepare: claimSublimitsPrepare(params),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_previous_coverage_breakdown.title',
        },
        size: 'h3',
      },
      {
        type: 'text',
        emphasis: 'default',
        containsHTML: true,
        color: 'grey500',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_previous_coverage_breakdown.description',
        },
        style: 'body1',
      },
      claimSublimitInfoBox(params),
    ],
    subFlow: params.subFlow,
    nextStep,
  } as const satisfies AnyStepConfiguration
}

export default dental_previous_coverage_breakdown
